import React from 'react';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDeactivate({ projectId, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ projectMember }) => <>{projectMember?.member?.name}</>;

  return (
    <BulkActionModal
      title="Deactivate Team Members"
      confirmText="Deactivate"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .members()
          .bulkSetActiveStatus(ids, false)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will deactivate ${
        ids.length === 1 ? 'the selected team member' : `the ${ids.length} selected team members`
      } on this project. Project Admins will be skipped.`}
    </BulkActionModal>
  );
}
